import React from "react";
import Tooltip from "@hyro-components/Tooltip";
import { StyledButton } from "../HeaderStyles";
import CubeIcon from "src/icons/CubeIcon";
import useBuildButton from "./BuildButton.hook";
import { BUILD_BUTTON_TEXT } from "./BuildButton.consts";
import { CircularProgress } from "@mui/material";
import ReviewChangesDialog from "@hyro-components/Dialogs/review-changes/ReviewChangesDialog";
import { REVIEW_GATES } from "@hyro-components/Dialogs/review-changes/reviewChanges.consts";

const BuildButton = () => {
  const {
    isLoading,
    isBuilding,
    isBuildDisabled,
    getBuildTooltip,
    handleBuildClick,
    isReviewOpen,
    closeReview,
    confirmReview
  } = useBuildButton();

  const getIcon = () => {
    if (isLoading) {
      return <CircularProgress size={16} sx={{ color: "grey.400" }} />;
    }

    return <CubeIcon disabled={isBuildDisabled} />;
  };

  return (
    <>
      <Tooltip title={getBuildTooltip()} tooltipStyle={{ whiteSpace: "pre-line" }} testId="build-button">
        <StyledButton
          data-testid="page-build-button"
          extraPadding={!isBuilding}
          loadingPosition="start"
          startIcon={getIcon()}
          onClick={handleBuildClick}
          disabled={isBuildDisabled}
          variant="outlined"
        >
          {isBuilding ? BUILD_BUTTON_TEXT.BUILDING : BUILD_BUTTON_TEXT.BUILD}
        </StyledButton>
      </Tooltip>
      {isReviewOpen && (
        <ReviewChangesDialog open gate={REVIEW_GATES.BUILD} onConfirm={confirmReview} onCancel={closeReview} />
      )}
    </>
  );
};

export default BuildButton;
